
import { BaseUnitOfWorkRequest } from "../../utilities/unit-of-work-observer";
import { UserModel } from "./user.models";
import { DepartmentModel } from "./departments.models";
import { RoleModel } from "./roles.models";
import { QueryFilter } from "../queries/queries.models";
import { OdataGridListView } from "../../views/components/odata-grid-list-view/odata-grid-list-view";

export interface SearchBranchRequest {
    branchId?: number;
    searchText: string;
    isAnd: boolean;
    page: number;
    recordsPerPage: number;
}

export interface SearchBranchResponse {
    branches: BranchModel[];
    pages: number;
}

export interface DeleteBranchRequest {
    branchIds: number[];
}

export interface CloneBranchRequest {
    branchId: number;
    branchName: string;
    cloneDepartments: boolean;
    cloneRoles: boolean;
    assignRoleDashboards: boolean;
    assignRoleValidations: boolean;
    assignRolePermissions: boolean;
    assignDepartmentDashboards: boolean;
    assignDepartmentPermissions: boolean;
    assignDepartmentValidations: boolean;
    assignBranchDashboards: boolean;
    assignBranchPermissions: boolean;
    assignBranchValidations: boolean;
}

export interface DeleteBranchResponse {
}

export interface BranchResponse {
    branch: BranchModel;
}

export interface CloneBranchResponse { }

export interface PersistBranchRequest extends BaseUnitOfWorkRequest { }

export interface PersistBranchResponse {
    branch: BranchModel;
}

export interface GetBranchRequest {
    branchId: number;
}

export interface GetBranchResponse {
    isSuccess: boolean;
    branch: BranchModel;
}

export interface ChangeActivationStateRequest {
    id: number;
    authorizeDeactivation: boolean;
}

export interface ChangeActivationStateResponse {
    isSuccess: boolean;
    unauthorizedDeactivation: boolean;
}

export interface BranchModel {
    isActive: boolean;
    branchId: number;
    parentId?: number;
    managerId?: number;
    branchRegionId?: number;
    name: string;
    code: string;
    image: string;
    isHQ?: boolean;
    isBranch?: boolean;
    isSubBranch?: boolean;
    users: UserModel[];
    permissions: BranchPermissionModel[];
    departments: DepartmentModel[];
    isDefault?: boolean;
    sequenceNumber?: number;
}

export interface BranchPermissionModel {
    dbId: number;
    permissionId: number;
    parameters: string;
    branchId: number;
}

export interface ManageBranchesPane {
    uri?: string;
    title: string;
    type: ManageBranchesPaneEnum;
    selectedItem?: BranchModel | DepartmentModel | RoleModel;
    id: string;
    parentId: string;
    initialFilters?: QueryFilter[];
    searchFilters?: string[];
    showCloseButton: boolean;
    listVM?: OdataGridListView;
    element?: HTMLElement;
    fallbackText?: string;
}

export enum ManageBranchesPaneEnum {
    Branch = 1,
    Department = 2,
    Role = 3,
    Subbranch = 4,
    Compose = 5
}